import { useCourseParams } from "components/hooks/useCourseParams";
import { useTeachingSemester } from "./useTeachingSemester";

export function useTeachingCourse() {
  const { classId } = useCourseParams();
  const { classes: semesterCourses = [] } = useTeachingSemester() || {};
  return semesterCourses.find((course) => course.course_id === classId);
}
